module.exports = __webpack_public_path__ + "img/fb14.860cf62a.jpg";